import React from "react";

import { useToggleAlertRule } from "api/api-hooks/alert-rules-hooks";
import { AlertRuleDTO } from "api/model/alerts/alert-types";
import { InputSwitch } from "primereact/inputswitch";

type EnabledToggleProps = {
  rule: AlertRuleDTO;
};

const EnabledToggle: React.FC<EnabledToggleProps> = ({ rule }) => {
  const { mutate: toggle, isPending } = useToggleAlertRule();

  return (
    <InputSwitch
      checked={rule.enabled}
      onChange={() => toggle({ ruleId: rule.id, enabled: !rule.enabled })}
      disabled={isPending}
    />
  );
};

export default EnabledToggle;
